export default {
  default: () => import("/builds/coingroup/fishcoin/market-client/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/builds/coingroup/fishcoin/market-client/layouts/empty.vue").then(m => m.default || m),
  "full-screen": () => import("/builds/coingroup/fishcoin/market-client/layouts/full-screen.vue").then(m => m.default || m),
  "header-only": () => import("/builds/coingroup/fishcoin/market-client/layouts/header-only.vue").then(m => m.default || m)
}